import { render, staticRenderFns } from "./ManageServiceOrder.vue?vue&type=template&id=b6c23cdc&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageServiceOrder.vue?vue&type=style&index=0&id=b6c23cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c23cdc",
  null
  
)

export default component.exports